module.exports = __webpack_public_path__ + "static/img/ninja-can-22.05b11ecc.png";